import Model, { attr, belongsTo } from '@warp-drive/legacy/model';

import {
  buildValidations,
  validator,
} from 'umg-ember-backend/utils/validations';

const Validations = buildValidations({
  categoryId: [validator('belongs-to'), validator('presence', true)],
  city: validator('presence', true),
  email: validator('format', {
    type: 'email',
    allowNonTld: true,
  }),
  name: validator('presence', true),
  street: validator('presence', true),
  zipcode: validator('presence', true),
});

export default class OrganizationModel extends Model.extend(Validations) {
  @attr('string') city;
  @attr('string') email;
  @attr('string') fax;
  @attr('string') fon;
  @attr('string') hrb;
  @attr('string') name;
  @attr('string') registerCourt;
  @attr('string') shortName;
  @attr('string') street;
  @attr('string') taxAuthorities;
  @attr('string') taxNumber;
  @attr('string') text;
  @attr('string') ustIdent;
  @attr('string') zipcode;

  // CMS fields
  @attr('number', { defaultValue: 2 }) cmsState;
  @attr cmsKilldate;
  @attr cmsLivedate;

  // Meta fields
  @attr cmsCreated;
  @attr cmsDeleted;
  @attr cmsLocktime;
  @attr cmsModified;
  @attr() cmsHistory;
  @belongsTo('user', { async: true, inverse: null }) cmsOwnerId;
  @belongsTo('user', { async: true, inverse: null }) cmsCreatorId;
  @belongsTo('user', { async: true, inverse: null }) cmsLockerId;
  @belongsTo('user', { async: true, inverse: null }) cmsModifierId;

  // Relations
  @belongsTo('asset', { async: true, inverse: null }) assetId;
  @belongsTo('category', { async: true, inverse: null }) categoryId;
  @belongsTo('link', { async: true, inverse: null }) linkId;

  // Getter and setter
  get displayHeadline() {
    return this.name;
  }

  get displayLabel() {
    return this.name;
  }

  get organId() {
    return this.name;
  }
}
